import script from "./CellSelectItemsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CellSelectItemsList.vue?vue&type=script&setup=true&lang=js"

import "./CellSelectItemsList.vue?vue&type=style&index=0&id=1642208c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1642208c"]])

export default __exports__